import { useEffect, useRef } from 'react';

/**
 * Ferme sur Échap. Les trois surfaces modales de l'app se fermaient uniquement
 * au clic sur une croix ou sur le fond : au clavier, on y restait piégé.
 *
 * Le rappel passe par une ref pour que l'écouteur soit posé une fois, même
 * quand l'appelant reconstruit sa fermeture à chaque rendu.
 */
export function useEscape(onClose: () => void): void {
  const handler = useRef(onClose);
  handler.current = onClose;

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') handler.current();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);
}
